module.exports = __webpack_public_path__ + "static/media/steve.304b1eaf.jpg";